export default __webpack_public_path__ + "favicons/mstile-150x150.png";